<template>
        <!-- 账单明细列表 -->
        <el-table :key="0" :data="list" stripe v-loading="loading" :element-loading-text="loadingText" border
                    fit highlight-current-row class="w-100">
            <!-- 保/批单号 -->
            <el-table-column align="left" label="保单号" >
            <template slot-scope="scope">
                <!-- <span v-if="$perm(['company.view_insurance_company'])" class="text-link"
                    @click="handleUpdate(scope.row.id)">{{scope.row.policy_number}}</span> -->
                <span >{{scope.row.policy_number}}</span>
            </template>
            </el-table-column>

            <!-- 保险公司 -->
            <el-table-column align="left" label="保险公司" >
            <template slot-scope="scope">
                <span>{{ scope.row.company}}</span>
            </template>
            </el-table-column>

            <!-- 实收保费(实收币种) -->
            <el-table-column align="left" label="实收保费" >
            <template slot-scope="scope">
                <span>{{ scope.row.premium | parsecurrency }}</span>
            </template>
            </el-table-column>

            <!-- 费用比率 -->
            <el-table-column align="left" label="费用比率" >
            <template slot-scope="scope">
                <span>{{ scope.row.commission_rate}}</span>
            </template>
            </el-table-column>

            <!-- 费用金额(人民币)-->
            <el-table-column align="left" label="费用金额" >
            <template slot-scope="scope">
                <span>{{ scope.row.commission | parsecurrency }}</span>
            </template>
            </el-table-column>


            <!-- 保费实收日期 -->
            <el-table-column align="left" label="保费实收日期" >
            <template slot-scope="scope">
                <span>{{ scope.row.paid_time | parseTime('{y}年{m}月{d}日') }}</span>
            </template>
            </el-table-column>

        </el-table>
</template>

<script>
import { formatCurrency } from '@/utils/misc'
export default {
    name: 'billing-record-list-da-jia',
    components: {
    },
    filters: {
      parsecurrency: function(value){
        let v = parseFloat(value).toFixed(4)
        return formatCurrency(v, 2)
      },
    },
    props: [
        'list',
        'loading',
        'loadingText'
    ]
}
</script>
<style lang="scss">

</style>
